import { useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import Button from 'src/components/button/Button';
import Input from 'src/components/input/Input';
import Loader from 'src/components/loader/Loader';
import logoIcon from 'src/icons/logo.svg';
import API from 'src/utils/api';
import { isValidPassword } from 'src/utils/forms';

const ResetPassword = () => {
    const { token } = useParams();

    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!password || !confirmPassword) {
            setLoading(false);
            return toast.error('Please enter a value for both fields');
        }

        if (password !== confirmPassword) {
            setLoading(false);
            return toast.error("Passwords don't match");
        }

        if (!isValidPassword(password)) {
            return toast.error('Please enter a valid password (between 6 and 255 characters long)', { duration: 4000 });
        }

        try {
            const response = await API.post(
                '/user/reset-password',
                { password },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.status === 200) {
                toast.success('Password reset successfully!');
                setTimeout(() => {
                    window.location.href = '/login';
                }, 2000);
            }
            if (response.status !== 200) {
                toast.error('Could not reset your password. Either your link expired or an unexpected error occured', {
                    duration: 4000,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error('Could not reset your password. Either your link expired or an unexpected error occured', {
                duration: 4000,
            });
        }
    };

    if (loading) return <Loader className="h-screen" />;

    return (
        <div>
            <div className="w-screen flex justify-center absolute mt-4">
                <img src={logoIcon} alt="Payonix logo" width={40} />
            </div>
            <div className="flex items-center justify-center w-screen h-screen max-w-screen-2xl mx-auto">
                <form className="flex flex-col w-full px-8 md:px-0 md:w-5/12 xl:w-1/3">
                    <strong className="text-4xl mb-8 text-center">Reset your password</strong>
                    <Input
                        type="password"
                        value={password}
                        setValue={setPassword}
                        label="Password"
                        fieldName="password"
                    />
                    <Input
                        type="password"
                        value={confirmPassword}
                        setValue={setConfirmPassword}
                        label="Confirm Password"
                        fieldName="confirmPassword"
                    />
                    <Button primary text="Reset password" className="mt-8" type="button" onClick={onSubmit} />
                </form>
            </div>
            <div className="w-screen flex justify-center absolute bottom-0 mb-4 text-gray-darker text-xs">
                © 2022 Payonix.com. All rights reserved
            </div>
        </div>
    );
};

export default ResetPassword;
